// extracted by mini-css-extract-plugin
export var legendIndicator = "_fs-1";
export var legendRight = "_fs-0";